export const CFG_MEDIA = [
  {
    src: "/assets/generator-panel.jpg",
    tag: "500W Prototype",
    title: "Control & connection panel — built in Sierra Leone by BNM",
  },
  {
    src: "/assets/cfg-5kva-2.jpg",
    tag: "5kVA Development Unit",
    title: "Drive assembly and battery bank under integration",
  },
  {
    src: "/assets/cfg-5kva-3.jpg",
    tag: "5kVA Development Unit",
    title: "The 5kVA unit on its mobile frame",
  },
];


export const COMPANY = {
  name: "BNM Sustainable Energy Limited",
  short: "BNM",
  tagline: "Engineering a Cleaner, Smarter Energy Future.",
  addressLines: ["Waterloo, Prince Alfred Road, Banga Farm", "Sierra Leone"],
  phoneDisplay: "+232 90712518",
  phoneHref: "tel:+23290712518",
  emails: ["inforbnmenergy@gmail.com", "bnmsustainableenergylimited@gmail.com"],
  socials: {
    linkedin: "https://www.linkedin.com/company/bnm-sustainable-energy-limited",
    facebook: "https://www.facebook.com/profile.php?id=61579459263404",
    x: "https://x.com/limitedbnm?s=11",
  },
};

export const ASSETS = {
  logo: "/assets/logo-official.jpg",
  generator: "/assets/generator.jpg",
};

export const NAV = {
  primary: [
    { label: "About", to: "/about" },
    { label: "Technology", to: "/technology" },
    { label: "Projects", to: "/projects" },
    { label: "Sustainability", to: "/sustainability" },
  ],
  products: [
    { label: "Products & Solutions", to: "/products", desc: "The BNM product portfolio" },
    { label: "Carbon Free Generator", to: "/carbon-free-generator", desc: "Our flagship technology" },
  ],
  company: [
    { label: "Innovation & R&D", to: "/innovation" },
    { label: "News & Insights", to: "/news" },
    { label: "Gallery", to: "/gallery" },
    { label: "Press Kit", to: "/press" },
    { label: "Partners", to: "/partners" },
  ],
};

export const MARQUEE_ITEMS = [
  "Clean Energy",
  "Engineering",
  "Sierra Leone",
  "Carbon-Free Power",
  "Energy Access",
  "African Innovation",
  "Hybrid Systems",
  "Sustainable Futures",
];

export const MANIFESTO = [
  {
    index: "01",
    title: "Energy Autonomy",
    text: "We believe reliable power should not depend on fragile supply chains or carbon-intensive fuels. BNM develops clean generation and storage technologies designed for real conditions — off-grid, grid-fragile and fast-growing communities.",
  },
  {
    index: "02",
    title: "Engineered in Sierra Leone",
    text: "BNM is built from Waterloo, Sierra Leone — proof that advanced energy engineering can originate in Africa, for Africa, and compete internationally. Local talent, local problems, world-class solutions.",
  },
  {
    index: "03",
    title: "Carbon-Free Ambition",
    text: "Our flagship Carbon Free Generator programme targets practical, hybrid carbon-free power — from today's 500W prototype toward a 5kVA-class system — without compromising on reliability or engineering rigour.",
  },
];

export const PILLARS = [
  {
    title: "Engineering-Led",
    text: "Technology development grounded in disciplined engineering, testing and iteration — not promises.",
  },
  {
    title: "Built for African Contexts",
    text: "Designed for the realities of energy access in Sierra Leone and comparable markets across the continent.",
  },
  {
    title: "Sustainability First",
    text: "Carbon-free generation and responsible development sit at the centre of every BNM product decision.",
  },
  {
    title: "Partnership Driven",
    text: "We build with investors, institutions, NGOs, researchers and governments to scale what works.",
  },
];

export const PRODUCTS = [
  {
    name: "BNM Solar Energy Calculator",
    status: "Live — Digital Service",
    blurb:
      "Size your solar system in minutes: pick your appliances, get a free energy estimate, then unlock a professional BNM design with panels, batteries, inverter, cables and a full bill of materials.",
    to: "/solar",
    featured: false,
    live: true,
  },
  {
    name: "BNM Carbon Free Generator",
    status: "In Development — Prototype Phase",
    blurb:
      "Our flagship clean-generation technology. A 500W prototype today, evolving toward a 5kVA-class hybrid carbon-free generator for homes, institutions and enterprises.",
    to: "/carbon-free-generator",
    featured: true,
  },
  {
    name: "Hybrid Energy Systems",
    status: "Under Development",
    blurb:
      "Integrated generation and storage architectures that combine carbon-free generation with renewable inputs for dependable, always-available power.",
    to: "/contact",
    featured: false,
  },
  {
    name: "Community Power Solutions",
    status: "Coming Soon",
    blurb:
      "Configurable energy packages under evaluation for schools, clinics, farms and rural community infrastructure.",
    to: "/contact",
    featured: false,
  },
  {
    name: "Energy Storage Systems",
    status: "Concept Stage",
    blurb:
      "Storage-first product concepts in early research, intended to pair with BNM generation technologies.",
    to: "/contact",
    featured: false,
  },
];

export const PROJECTS = [
  {
    name: "Powering Learning Without Limits",
    tag: "Energy Access · Education",
    status: "Project Overview Coming Soon",
    text: "A BNM initiative focused on bringing dependable clean power to learning environments. Full project documentation will be published as the programme is formalised.",
  },
  {
    name: "Salone Agro Rider",
    tag: "Agri-Mobility · Clean Energy",
    status: "Project Overview Coming Soon",
    text: "An initiative exploring clean-energy applications for agricultural productivity and mobility in Sierra Leone. Details will be shared as development progresses.",
  },
];

export const SDGS = [
  { n: 7, name: "Affordable & Clean Energy", note: "Expanding access to reliable, sustainable power." },
  { n: 9, name: "Industry, Innovation & Infrastructure", note: "Building African clean-tech engineering capability." },
  { n: 11, name: "Sustainable Cities & Communities", note: "Resilient energy for homes, schools and clinics." },
  { n: 13, name: "Climate Action", note: "Developing carbon-free alternatives to fossil generation." },
];

export const CFG_SPECS = [
  { label: "Prototype Output", value: "500 W (prototype unit)" },
  { label: "Development Target", value: "Up to 5 kVA hybrid carbon-free system" },
  { label: "System Architecture", value: "Hybrid carbon-free generation with integrated energy storage" },
  { label: "Development Status", value: "Prototype phase — not yet commercially deployed" },
  { label: "Dimensions & Weight", value: "Specification under development" },
  { label: "Runtime & Endurance", value: "Specification under development" },
  { label: "Input / Charging", value: "Specification under development" },
  { label: "Certification & Standards", value: "Specification under development" },
];

export const CFG_APPLICATIONS = [
  "Homes",
  "Small businesses",
  "Schools",
  "Clinics",
  "Farms",
  "Rural communities",
  "Small enterprises",
  "Emergency power",
];

export const CFG_FAQ = [
  {
    q: "Is the Carbon Free Generator available to buy?",
    a: "Not yet. The BNM Carbon Free Generator is in active prototype development. A 500W prototype exists today, and the engineering roadmap targets a hybrid system of up to 5kVA. Organisations interested in pilots or early partnerships are invited to contact us.",
  },
  {
    q: "How does the system work?",
    a: "The system is a hybrid carbon-free generation and storage architecture. Detailed technical documentation is part of BNM's ongoing engineering work and is shared with technical and investment partners under appropriate agreements.",
  },
  {
    q: "Does it produce zero emissions?",
    a: "The Carbon Free Generator is being developed as a carbon-free alternative to conventional fuel generators. Final verified performance and emissions data will be published once testing and validation are complete.",
  },
  {
    q: "Where is BNM based?",
    a: "BNM Sustainable Energy Limited operates from Waterloo, Prince Alfred Road, Banga Farm, Sierra Leone, with the ambition to scale across Africa and internationally.",
  },
  {
    q: "How can investors or partners engage?",
    a: "Through the partnerships page or the contact form. We welcome conversations with investors, development organisations, NGOs, government institutions, researchers and technology companies.",
  },
];

export const INQUIRY_TYPES = [
  { value: "general", label: "General Inquiry" },
  { value: "product", label: "Product Inquiry" },
  { value: "partnership", label: "Partnership" },
  { value: "investment", label: "Investment" },
  { value: "technology", label: "Technology" },
  { value: "media", label: "Media" },
  { value: "other", label: "Other" },
];

export const GALLERY_CATEGORIES = ["All", "Technology", "Projects", "Innovation", "Events", "Community", "Company"];

export const GALLERY_ITEMS = [
  {
    src: "/assets/generator.jpg",
    category: "Technology",
    title: "BNM Carbon Free Generator — 500W Prototype",
    caption: "Official BNM photo of the Carbon Free Generator prototype development unit.",
    bnm: true,
  },
  {
    src: "/assets/generator-panel.jpg",
    category: "Technology",
    title: "Carbon Free Generator — Panel Detail",
    caption: "Official BNM photo — 500W prototype panel, built in Sierra Leone.",
    bnm: true,
  },
  {
    src: "/assets/workshop-testing.jpg",
    category: "Innovation",
    title: "Workshop Testing Session",
    caption: "Official BNM photo — prototype under test powering lighting loads, with companion power-bank units.",
    bnm: true,
  },
  {
    src: "/assets/cfg-5kva-1.jpg",
    category: "Technology",
    title: "5kVA Development Unit",
    caption: "Official BNM photo — 5kVA-class Carbon Free Generator under development.",
    bnm: true,
  },
  {
    src: "/assets/cfg-5kva-2.jpg",
    category: "Technology",
    title: "5kVA Drive & Battery Integration",
    caption: "Official BNM photo — 5kVA development unit detail.",
    bnm: true,
  },
  {
    src: "/assets/cfg-5kva-3.jpg",
    category: "Technology",
    title: "5kVA Unit on Mobile Frame",
    caption: "Official BNM photo — 5kVA development unit.",
    bnm: true,
  },
  {
    src: "/assets/mamadu-bah.jpg",
    category: "Company",
    title: "Mamadu Bah — Founder & CEO",
    caption: "Official portrait of BNM founder and CEO Mamadu Bah.",
    bnm: true,
  },
  {
    src: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    category: "Technology",
    title: "Electrical Systems Engineering",
    caption: "Representative industry imagery — not a BNM installation.",
  },
  {
    src: "https://images.pexels.com/photos/4254158/pexels-photo-4254158.jpeg?auto=compress&cs=tinysrgb&w=1200",
    category: "Projects",
    title: "Solar Field Operations",
    caption: "Representative industry imagery — not a BNM project site.",
  },
  {
    src: "https://images.unsplash.com/photo-1688841747582-41097036109d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    category: "Innovation",
    title: "Field Engineering & Inspection",
    caption: "Representative industry imagery — not a BNM team member.",
  },
  {
    src: "https://images.pexels.com/photos/9799719/pexels-photo-9799719.jpeg?auto=compress&cs=tinysrgb&w=1200",
    category: "Technology",
    title: "Mobile Solar Power Unit",
    caption: "Representative industry imagery — not a BNM product.",
  },
  {
    src: "https://images.unsplash.com/photo-1786913507799-0ddbb3e7dbb6?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    category: "Company",
    title: "Industrial Energy Infrastructure",
    caption: "Representative industry imagery.",
  },
  {
    src: "https://images.pexels.com/photos/9799704/pexels-photo-9799704.jpeg?auto=compress&cs=tinysrgb&w=1200",
    category: "Community",
    title: "Community Solar Lighting",
    caption: "Representative industry imagery — not a BNM deployment.",
  },
  {
    src: "https://images.unsplash.com/photo-1760425447194-1ea92f805f5a?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    category: "Projects",
    title: "Wind Energy Landscape",
    caption: "Representative industry imagery — not a BNM project site.",
  },
  {
    src: "https://images.pexels.com/photos/35082119/pexels-photo-35082119.jpeg?auto=compress&cs=tinysrgb&w=1200",
    category: "Innovation",
    title: "Safety & Engineering Practice",
    caption: "Representative industry imagery.",
  },
];

export const PARTNER_AUDIENCES = [
  {
    title: "Investors",
    text: "Back the development of carbon-free generation technology built for high-growth African energy markets.",
  },
  {
    title: "Energy Companies",
    text: "Co-develop hybrid systems, distribution models and market-entry pathways with BNM engineering.",
  },
  {
    title: "NGOs & Development Organisations",
    text: "Partner on energy-access programmes for schools, clinics and underserved communities.",
  },
  {
    title: "Government Institutions",
    text: "Collaborate on national energy-access, industrialisation and climate objectives.",
  },
  {
    title: "Research Institutions",
    text: "Joint research, testing and validation across generation, storage and hybrid architectures.",
  },
  {
    title: "Technology Companies",
    text: "Integrate components, controls, software and manufacturing capability into the BNM platform.",
  },
];

export const ARTICLES = [
  {
    slug: "carbon-free-generator-development-advances",
    title: "BNM Sustainable Energy Limited Advances Development of the Carbon-Free Generator",
    category: "Innovation & Technology",
    date: "September 2026",
    dateIso: "2026-09-01",
    author: "BNM Communications",
    image: "/assets/generator.jpg",
    imageAlt: "The BNM Carbon Free Generator 500W prototype unit",
    tags: ["Carbon Free Generator", "Clean Energy", "Product Development"],
    excerpt:
      "BNM is advancing development of its Carbon-Free Generator — a clean-energy solution designed to provide reliable electricity for homes, schools, small businesses and communities facing power-access challenges.",
    body: [
      "BNM Sustainable Energy Limited is advancing the development of its Carbon-Free Generator, an innovative clean-energy solution designed to provide reliable electricity for homes, schools, small businesses, and other communities facing challenges with access to dependable power.",
      "The Carbon-Free Generator is part of BNM Sustainable Energy Limited's broader commitment to developing practical and affordable energy technologies for Sierra Leone and the wider African market.",
      "The company is currently focused on product refinement, testing, documentation, and preparing the technology for future deployment and commercial production.",
      "BNM Sustainable Energy Limited believes locally developed technologies can play an important role in expanding access to clean and reliable energy while supporting innovation, entrepreneurship, and sustainable development across Africa.",
    ],
  },
  {
    slug: "building-sierra-leones-next-generation-clean-energy-innovation",
    title: "Building Sierra Leone's Next Generation of Clean Energy Innovation",
    category: "Company News",
    date: "September 2026",
    dateIso: "2026-09-01",
    author: "BNM Communications",
    image: "/assets/workshop-testing.jpg",
    imageAlt: "BNM workshop testing session with prototype and lighting loads",
    tags: ["Company", "Sierra Leone", "Innovation Ecosystem"],
    excerpt:
      "Founded by entrepreneur and clean-energy innovator Mamadu Bah, BNM is developing practical clean-energy technologies while supporting Sierra Leone's growing innovation ecosystem.",
    body: [
      "BNM Sustainable Energy Limited is a Sierra Leonean clean-energy company focused on developing innovative technologies that address real-world energy challenges.",
      "Founded by entrepreneur and clean-energy innovator Mamadu Bah, the company is working to develop solutions that can contribute to more reliable and accessible electricity while supporting Sierra Leone's growing innovation and technology ecosystem.",
      "BNM's work is centered around practical engineering, clean energy, product development, and the long-term goal of creating technologies that can serve communities in Sierra Leone and eventually markets across Africa.",
      "As the company continues to develop its technologies, BNM Sustainable Energy Limited is seeking opportunities to collaborate with investors, engineers, manufacturers, researchers, development organizations, and other partners interested in advancing clean-energy innovation.",
    ],
  },
  {
    slug: "bnm-looks-toward-regional-expansion",
    title: "BNM Sustainable Energy Limited Looks Toward Regional Expansion",
    category: "Future & Growth",
    date: "September 2026",
    dateIso: "2026-09-01",
    author: "BNM Communications",
    image: "/assets/cfg-5kva-1.jpg",
    imageAlt: "The BNM 5kVA-class Carbon Free Generator development unit",
    tags: ["Growth", "Partnerships", "Manufacturing"],
    excerpt:
      "BNM is preparing its next stage of growth: product development, strategic partnerships, manufacturing opportunities and future expansion beyond Sierra Leone.",
    body: [
      "BNM Sustainable Energy Limited is preparing for the next stage of its growth with a focus on product development, strategic partnerships, manufacturing opportunities, and future expansion beyond Sierra Leone.",
      "The company's long-term vision is to develop and manufacture innovative clean-energy technologies that can respond to the energy needs of communities and businesses across Africa.",
      "As part of this vision, BNM is exploring opportunities for technology partnerships, manufacturing collaboration, investment, research and development, and market expansion.",
      "The company remains committed to developing solutions from Sierra Leone while building relationships that can help take African clean-energy innovation to a wider regional and international market.",
      "BNM Sustainable Energy Limited welcomes conversations with potential investors, technical partners, manufacturers, institutions, and organizations interested in supporting the development and deployment of innovative clean-energy solutions.",
    ],
  },
];

export const FOUNDER = {
  name: "Mamadu Bah",
  role: "Founder & CEO",
  tagline:
    "Clean Energy & Engineering Innovation Entrepreneur · Youth & Climate Action Advocate · Technology & Innovation Leader",
  portrait: "/assets/mamadu-bah.jpg",
  bio: [
    "Mamadu Bah is a Sierra Leonean entrepreneur, technology and clean-energy innovator, youth leader and community development advocate focused on using innovation and entrepreneurship to address real-world challenges across Africa.",
    "As Founder and CEO of BNM Sustainable Energy Limited, he leads the development of practical technologies designed to improve access to reliable and sustainable electricity — including the Carbon-Free Generator, being developed as an alternative energy solution for homes, schools, small businesses and communities facing energy-access challenges. His long-term vision is to develop and manufacture innovative energy technologies in Sierra Leone and expand their impact across Africa.",
    "Beyond entrepreneurship, Mamadu is a Climate Action Ambassador with Sierra Leone's Directorate of Science, Technology and Innovation (DSTI) and a Global Goals Sustainability Ambassador, and has taken part in international and regional platforms including the World Bank Group Youth Summit, YALI, the Aspire Leaders Program (Cohort 3), the AfCFTA youth ecosystem, the Pan-African Youth Impact Bootcamp and the Banyani African Resilience Academy.",
    "His innovation journey has been recognised through initiatives such as Life By Design, where he was a second-place recipient, and ClimateLaunchpad Sierra Leone. He is also the founder of Salone Voice Alliance (SVA), a youth-focused community initiative amplifying vulnerable voices across education, leadership, climate action and community development.",
    "His ambition: a future where African innovators are not only consumers of technology, but its designers, engineers, founders and manufacturers.",
  ],
  recognition: [
    "DSTI Climate Action Ambassador",
    "Global Goals Sustainability Ambassador",
    "Aspire Leaders Program — Cohort 3",
    "World Bank Group Youth Summit",
    "YALI",
    "AfCFTA Youth Ecosystem",
    "ClimateLaunchpad Sierra Leone",
    "Life By Design — 2nd Place",
    "Founder, Salone Voice Alliance",
  ],
  areas: [
    "Clean Energy & Engineering Innovation",
    "Renewable Energy",
    "Technology & Entrepreneurship",
    "Climate Action",
    "Youth Leadership",
    "Sustainable Development",
    "Community Development",
    "African Innovation",
    "Product Development",
  ],
};

export const PRESS = {
  boilerplateShort:
    "BNM Sustainable Energy Limited is a Sierra Leonean clean-energy technology company developing the Carbon Free Generator and sustainable energy solutions for Africa. Founded by entrepreneur and clean-energy innovator Mamadu Bah, the company operates from Waterloo, Sierra Leone.",
  boilerplateStandard:
    "BNM Sustainable Energy Limited is a Sierra Leonean clean-energy technology company developing practical, affordable energy technologies for Sierra Leone and the wider African market. Founded by entrepreneur and clean-energy innovator Mamadu Bah and headquartered in Waterloo, Sierra Leone, the company's flagship technology is the BNM Carbon Free Generator — a carbon-free generation and storage system with a 500W prototype completed and a 5kVA-class hybrid system in development. BNM's mission is to expand access to reliable, sustainable and future-ready power, with the long-term vision of developing and manufacturing innovative energy technologies in Sierra Leone and scaling their impact across Africa. The company welcomes collaboration with investors, engineers, manufacturers, researchers, development organizations and institutions advancing clean-energy innovation.",
  facts: [
    { label: "Company", value: "BNM Sustainable Energy Limited" },
    { label: "Founded by", value: "Mamadu Bah (Founder & CEO)" },
    { label: "Headquarters", value: "Waterloo, Prince Alfred Road, Banga Farm, Sierra Leone" },
    { label: "Industry", value: "Renewable Energy · Clean Technology · Engineering" },
    { label: "Flagship Technology", value: "BNM Carbon Free Generator — 500W prototype; 5kVA-class hybrid in development" },
    { label: "Development Status", value: "Prototype phase — not yet commercially deployed" },
    { label: "Phone", value: "+232 90712518" },
    { label: "Email", value: "inforbnmenergy@gmail.com · bnmsustainableenergylimited@gmail.com" },
  ],
  groups: [
    {
      title: "Brand",
      note: "Official logo. Do not recolor, stretch, crop or modify the artwork.",
      items: [{ name: "BNM Official Logo", file: "/assets/logo-official.jpg", format: "JPG" }],
    },
    {
      title: "Product Photography",
      note: "Official photos of BNM development-stage hardware from the Waterloo workshop.",
      items: [
        { name: "Carbon Free Generator — 500W Prototype", file: "/assets/generator.jpg", format: "JPG" },
        { name: "500W Prototype — Panel Detail", file: "/assets/generator-panel.jpg", format: "JPG" },
        { name: "Workshop Testing Session", file: "/assets/workshop-testing.jpg", format: "JPG" },
        { name: "5kVA Development Unit", file: "/assets/cfg-5kva-1.jpg", format: "JPG" },
        { name: "5kVA Drive & Battery Integration", file: "/assets/cfg-5kva-2.jpg", format: "JPG" },
        { name: "5kVA Unit on Mobile Frame", file: "/assets/cfg-5kva-3.jpg", format: "JPG" },
      ],
    },
    {
      title: "Leadership",
      note: "Official portrait for media and speaking engagements.",
      items: [{ name: "Mamadu Bah — Founder & CEO", file: "/assets/mamadu-bah.jpg", format: "JPG" }],
    },
  ],
  guidelines: [
    "Assets on this page may be used by media, partners and event organisers with credit: “Courtesy of BNM Sustainable Energy Limited”.",
    "The BNM logo must be used as supplied — no recolouring, stretching, cropping or modification.",
    "Product photographs show development-stage prototypes and should be captioned as such where relevant.",
    "Do not imply partnership, endorsement or certification by BNM without written confirmation.",
    "For interviews, filming requests or high-resolution assets, contact the BNM media team.",
  ],
};
